export default "__VITE_PUBLIC_ASSET__e67cc77a__"